import { useGrowl } from "PFApp/use_growl";
import { Button } from "PFComponents/button";
import { Icon } from "PFComponents/icon";
import AddIcon from "PFComponents/icons/add_icon";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import { useCreateTemplate } from "PFCore/hooks/queries/bookings/booking_export/use_create_template";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useTemplatePayloadProvider } from "../use_template_payload_provider";
import css from "./create_new_template.module.scss";

export const CreateNewTemplate = () => {
  const [isInputFieldVisible, setIsInputFieldVisible] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const { t } = useTranslation("bookingModule");
  const {
    mutateAsync: createTemplate,
    isSuccess,
    isLoading
  } = useCreateTemplate({
    onSuccess: () => {
      setIsInputFieldVisible(false);
    },
    onError: () => {
      growl({
        kind: "error",
        message: t("reports.exportWizard.errors.errorCreatingTemplates")
      });
    }
  });
  const provideTemplatePayload = useTemplatePayloadProvider();
  const growl = useGrowl();
  const handleCreateTemplate = () => createTemplate(provideTemplatePayload(templateName));

  return (
    <div className={css.templateContainer}>
      {!isInputFieldVisible && !isSuccess && (
        <button className={css.newTemplateButton} onClick={() => setIsInputFieldVisible(true)}>
          <AddIcon className={css.addIcon} /> {t("reports.exportWizard.createNewTemplate")}
        </button>
      )}
      {isInputFieldVisible && (
        <div className={css.templateInputContainer}>
          <InputFieldSet
            placeholder={t("reports.exportWizard.newTemplatePlaceholder")}
            inputClassName={css.input}
            value={templateName}
            onChange={(value: string) => {
              setTemplateName(value);
            }}
          />
          <Button kind="secondary" onClick={() => setIsInputFieldVisible(false)}>
            <Icon name="cross" size="sm" />
          </Button>
          <Button onClick={handleCreateTemplate} disabled={!templateName || isLoading}>
            <Icon name="check" size="sm" />
          </Button>
        </div>
      )}
      {isSuccess && <span>{t("reports.exportWizard.templateSuccessText")}</span>}
    </div>
  );
};
